export const titleStyle = ({ typography, functions: { pxToRem } }) => ({
  fontFamily: typography.lexendFont,
  fontSize: 24,
  lineHeight: 1.37,
  fontWeight: 600,
  // letterSpacing: "-0.8px",
  marginBottom: pxToRem(9),
});
